import * as React from "react";
import { connect } from "react-redux";
import { AppState } from "../../../../redux";
import { Entity, Person, GRAPHQL_TYPE_PERSON } from "@radivision/graphql";
import { isOwner } from "../../../../utilities/is-owner";
import { ProfilePicture } from "../../../page-framework/profile-picture-name/profile-picture";
import { getProfileInfo } from "../../../../utilities/get-profile-info";
import { Router } from "../../../../utilities/router";
import { DeleteCompanyButton } from "./delete-company-button";
import { AddCompanyButton } from "./add-company-button";

interface ComponentProps {
  subject: Person | Entity;
}

interface MapDispatchProps {}

interface MapStateProps {
  user: Person | null;
}

export type Props = ComponentProps & MapDispatchProps & MapStateProps;

export const ExperiencesComponent = (props: Props) => {
  const { subject, user } = props;
  const goTo = React.useCallback(
    (profileUrl) => (e) => {
      if (!profileUrl) return;
      e.preventDefault();
      Router.navigateTo(profileUrl);
    },
    [],
  );
  if (!subject || subject?.__typename !== GRAPHQL_TYPE_PERSON) return null;
  const owner = isOwner(subject, user);
  const person = subject as Person;
  const hasExperience = person?.experience?.edges?.length ? true : false;
  if (!owner && !hasExperience) return null;
  return (
    <Container>
      <div className="section-header">
        <h3 className="section-title">{owner ? "My" : ""} Experience</h3>
        {owner && <AddCompanyButton collection="experience" title={"Add experience"} />}
      </div>
      {/* person?.entities?.map((entity) */}
      {person?.experience?.edges?.map((edge) => {
        const entity = edge?.position?.entity;
        const { profileUrl } = getProfileInfo(entity);
        return (
          <div className="company-card" key={`entity-${entity.id}`}>
            <div className="company-logo">
              {owner && <DeleteCompanyButton entity={entity} collection="experience" />}
              {/* <a onClick={goTo(profileUrl)} href={profileUrl}> */}
              <ProfilePicture subject={entity} numberOfItems={2} />
              {/* </a> */}
            </div>
            <div className="company-text">
              <h3 className="company-name">
                <a href={profileUrl} onClick={goTo(profileUrl)}>
                  {entity?.name}
                </a>
              </h3>
              <div className="company-tagline">{entity?.tagLine}</div>
            </div>
          </div>
        );
      })}
      {owner && !hasExperience && (
        <h2 className="no-content">No companies listed in Experience section at the moment.</h2>
      )}
    </Container>
  );
};

const Container = ({ children }: React.PropsWithChildren<any>) => (
  <div className="experiences-companies">{children}</div>
);

const mapState = (state: AppState) => ({
  user: state.account.user,
});

const mapDispatch = {};

export const Experiences = connect(mapState, mapDispatch)(ExperiencesComponent);
